import React, { useCallback } from "react";
import { useParams, useHistory, useRouteMatch } from "react-router-dom";
import { Routes } from "@greeter-venue/utility/Routes";
import { ProductPageApiHandler } from "./ProductPageApiHandler";
import { useIonRouter } from "@ionic/react";

type Params = {
  id?: string;
};

export function ProductPageRouteHandler() {
  const routeMatch = useRouteMatch<Params>(
    Routes.mainGroup.venueTab.product.template()
  );
  const id = routeMatch?.params?.id;
  const history = useIonRouter();

  const handleProductCreated = useCallback(
    (productId: string) =>
      history.push(Routes.mainGroup.productCreated.route({ id: productId })),
    [history]
  );

  const handleProductDeleted = useCallback(() => {
    history.push(Routes.mainGroup.venueTab.root.route());
  }, [history]);

  return (
    <ProductPageApiHandler
      key={id}
      onProductCreated={handleProductCreated}
      onProductDeleted={handleProductDeleted}
      id={id}
    />
  );
}
